<template>
  <div class="lxn-w100">
    <div class="DevicesHub lxn-margin-auto lxn-pos-rel lxn-border-round lxn-overflow-hidden">
      <div :style="labelStyle" :class="$store.getters.language.floatClass" class="DevicesHub-right-label lxn-h100">
      </div>
      <div :class="$store.getters.language.floatClass" class="DevicesHub-left lxn-h100">
        <div :class="[$store.getters.language.floatClass, $store.getters.language.directionClass, $store.getters.language.textAlignClass, $store.getters.language.font]" class="DevicesHub-left-texts lxn-h100 lxn-overflow-hidden lxn-title">
          {{hub.name}}
          <br/>
          {{$store.getters.language.texts.Devices_Hub_IP}}:
          <div class="lxn-text-en lxn-text" style="direction: ltr; display: inline;">
            {{ipAddress }} {{ port }} {{  ipStatic }}
          </div>
          <br/>
          
          {{$store.getters.language.texts.Devices_Hub_Priviledge}}: {{accessLevel}}
        </div>
        <div :class="$store.getters.language.floatClass" class="DevicesHub-left-buttons lxn-h100">
          <div class="DevicesHub-top-buttons lxn-w100">
            <div class="lxn-float-left" @click="openSettings()">
              <ButtonIcon :size="25" bgColor="#1EA5DE" icon="cog" iconColor="#ffffff" :padding="5" />
            </div>
            <div class="lxn-float-right" @click="retryHubConnection()">
              <ButtonIcon v-if="connectionStatus == 'Local'" :size="25" bgColor="#3BB878" icon="local" iconColor="#ffffff" :padding="5" />
              <ButtonIcon v-else-if="connectionStatus == 'Online'" :size="25" bgColor="#3BB878" icon="online" iconColor="#ffffff" :padding="5" />
              <ButtonIcon v-else-if="connectionStatus == 'Connecting'" :size="25" bgColor="#F1BC52" icon="offline" iconColor="#ffffff" :padding="5" />
              <ButtonIcon v-else :size="25" bgColor="#53636C" icon="offline" iconColor="#ffffff" :padding="5" />
            </div>
          </div>
          <div :class="$store.getters.language.floatClassReverse" class="DevicesHub-bottom-buttons" @click="toggleShowNodes">
              <ButtonIcon :size="45" bgColor="#DEDEDE" :icon="showNodesButtonIcon" iconColor="#53636C" :padding="8" />
          </div>
        </div>
      </div>
    </div>
    <div v-show="showNodes" class="DevicesHub-wrapper-node lxn-margin-auto lxn-border-round">
      <slot>
      </slot>
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/ButtonIcon.vue'
import * as CONFIGS from '@/statics/configs.js'

export default {
  name: 'Hub',
  props: {
    index: Number
  },
  components: {
    ButtonIcon
  },
  data: function () {
    return {
      showNodes: this.$store.state.hubs.length == 1,
      hub: this.$store.state.hubs[this.index]
    }
  },
  computed: {
    connectionStatus: function () {
      if(this.hub.connectionStatus.local == CONFIGS.HUB_CONNECTION_STATUS_CONNECTED){
        return 'Local';
      }else if(this.hub.connectionStatus.online == CONFIGS.HUB_CONNECTION_STATUS_CONNECTED){
        return 'Online';
      }else if(this.hub.connectionStatus.local == CONFIGS.HUB_CONNECTION_STATUS_CONNECTING || this.hub.connectionStatus.online == CONFIGS.HUB_CONNECTION_STATUS_CONNECTING){
        return 'Connecting';
      }else{
        return 'Offline';
      }
    },
    labelStyle: function () {
      return "background-color: " + this.$store.state.themeMainColors[this.hub.color];
    },
    showNodesButtonIcon: function () {
      return this.showNodes ? 'up' : 'down';
    },
    accessLevel: function () {
      return this.hub.isOwner ? this.$store.getters.language.texts.Devices_Hub_accessOwner : this.$store.getters.language.texts.Devices_Hub_accessNormal
    },
    ipAddress: function () {
      return this.hub.ipAddress ? this.hub.ipAddress : 'xx.xx.xx.xx'
    },
    port: function () {
      return this.hub.staticIp ? ":"+this.hub.port : ''
    },
    ipStatic: function () {
      return this.hub.staticIp ? 'static' : ''
    }
  },
  methods: {
    toggleShowNodes: function () {
       this.showNodes = !this.showNodes;
    },
    openSettings: function () {
      this.$router.push('/hubSettings/' + this.hub.uuid);
    },
    retryHubConnection: function () {
      if(this.hub.connectionStatus.local == CONFIGS.HUB_CONNECTION_STATUS_CONNECTED){
        // this.$store.commit('setHubStatus', {
        //   hubIndex: this.index,
        //   connectionStatus: {
        //     local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
        //     online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
        //   },
        // });
      }else if(this.hub.connectionStatus.online == CONFIGS.HUB_CONNECTION_STATUS_CONNECTED){
        this.$store.commit('setHubStatus', {
          hubIndex: this.index,
          connectionStatus: {
            local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
          },
        });
      }else if(this.hub.connectionStatus.local == CONFIGS.HUB_CONNECTION_STATUS_CONNECTING || this.hub.connectionStatus.online == CONFIGS.HUB_CONNECTION_STATUS_CONNECTING){
        //hub is connecting, so do nothing
      }else{
        //hub is offline, it will retry automatically, so do nothing here
      }
    },
  }
}
</script>

<style>
  .DevicesHub {
    width: calc(100% - 36px);
    height: 100px;
    z-index: 1;
    margin-bottom: 14px;
    background-color: #ffffff;
  }
  .DevicesHub-right-label {
    width: 8px;
  }
  .DevicesHub-left {
    width: calc(100% - 8px);
    padding: 10px;
  }
  .DevicesHub-left-texts {
    width: calc(100% - 55px);
    line-height: 25px;
  }
  .DevicesHub-left-buttons {
    width: 55px;
  }
  .DevicesHub-top-buttons {
    height: 30px;
  }
  .DevicesHub-bottom-buttons {
    height: 50px;
    padding-top: 2px;
  }
  .DevicesHub-wrapper-node {
    width: calc(100% - 36px);
    margin-bottom: 15px;
    padding: 14px;
    background-color: #ffffff;
  }
</style>
